import { render } from "./TypeList.vue?vue&type=template&id=abc83da8&scoped=true"
import script from "./TypeList.vue?vue&type=script&lang=js"
export * from "./TypeList.vue?vue&type=script&lang=js"

import "./TypeList.vue?vue&type=style&index=0&id=abc83da8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc83da8"]])

export default __exports__